import { g } from "../../util/index.ts";
import { apronsActive, progressiveLuxuryTax } from "./aprons.ts";

const getLuxuryTaxAmount = (payroll: number, repeater = false) => {
	// Only apply luxury tax if hard cap is disabled!
	if (payroll > g.get("luxuryPayroll") && g.get("salaryCapType") !== "hard") {
		// With apron logic on: progressive brackets + a repeater surcharge. Otherwise ZenGM's
		// flat multiplier over the tax line.
		if (apronsActive()) {
			return progressiveLuxuryTax(payroll, repeater);
		}
		return g.get("luxuryTax") * (payroll - g.get("luxuryPayroll"));
	}

	return 0;
};

export default getLuxuryTaxAmount;
